import axiosInstance from '../axiosInstance';

const getTasksAPI = (page, size, isGroupTask) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/tulip-tasks?page=${page}&size=${size}&isGroupTask=${isGroupTask}`;
    return axiosInstance.get(url);
};

const acceptTaskAPI = (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/reverse/accept`;
    return axiosInstance.post(url, body);
};

const rejectTaskAPI = (requestId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/reverse/reject`;
    return axiosInstance.post(url, body);
};

export default {
    getTasksAPI,
    acceptTaskAPI,
    rejectTaskAPI,
};
